var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { Emit } from "vue-property-decorator";
// import { PrincipalService } from "~/services/business-service/principal.service"
import { ImportOthersDataExcelRecordService } from "~/services/dataimp-service/import-others-data-excel-record.service";
var ImportBatchRetireCase = /** @class */ (function (_super) {
    __extends(ImportBatchRetireCase, _super);
    function ImportBatchRetireCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.principalList = []; //委托方列表
        _this.importModel = {
            fileId: '',
            principalId: '' //委托方ID
        };
        _this.importRules = {
            fileId: { required: true, message: '请上传文件' },
        };
        _this.mfileList = [];
        return _this;
    }
    // @Dependencies(PrincipalService) private principalService: PrincipalService;
    ImportBatchRetireCase.prototype.close = function () {
        this.reset();
    };
    ImportBatchRetireCase.prototype.success = function () {
        this.$message.success("操作成功");
        this.close();
    };
    Object.defineProperty(ImportBatchRetireCase.prototype, "fileList", {
        get: function () {
            return this.mfileList;
        },
        set: function (val) {
            this.mfileList = val;
            this.importModel.fileId = val.length && val[0].response ? val[0].response.id : "";
        },
        enumerable: false,
        configurable: true
    });
    ImportBatchRetireCase.prototype.created = function () {
        // 获取委托方列表
        // this.principalService.findAll().subscribe(
        //   data => this.principalList = data,
        // )
    };
    /**
     * 表单重置
     */
    ImportBatchRetireCase.prototype.reset = function () {
        var upload = this.$refs['upload_case_import'];
        upload.reset();
        var form = this.$refs['form'];
        form.resetFields();
    };
    /**
     * 表单提交
     */
    ImportBatchRetireCase.prototype.submit = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.validate(function (valid) {
            if (!valid)
                return;
            _this.importOthersDataExcelRecordService
                .importPauseCase(_this.importModel)
                .subscribe(_this.success);
        });
    };
    __decorate([
        Dependencies(ImportOthersDataExcelRecordService)
    ], ImportBatchRetireCase.prototype, "importOthersDataExcelRecordService", void 0);
    __decorate([
        Emit('close')
    ], ImportBatchRetireCase.prototype, "close", null);
    __decorate([
        Emit('success')
    ], ImportBatchRetireCase.prototype, "success", null);
    ImportBatchRetireCase = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], ImportBatchRetireCase);
    return ImportBatchRetireCase;
}(Vue));
export default ImportBatchRetireCase;
